<template>
  <div class="page-container">
    <div class="page-content">
      <!-- Cabeçalho -->
      <div class="page-header">
        <div class="d-flex align-items-center mb-3">
          <h1 class="text-white">
            <i class="mdi mdi-handshake"></i> Tomadores
          </h1>
          <div class="d-flex gap-2 ml-auto align-items-center">
            <button
              @click="redirect('client-store')"
              class="btn btn-outline-white"
            >
              <i class="fa fa-plus-circle"></i>
              <span class="d-none d-md-inline ml-2">Novo Tomador</span>
            </button>
            <div class="btn-group">
              <button
                @click="$refs.showModalFilter.show()"
                class="btn btn-outline-white"
              >
                <i class="fa fa-filter"></i>
                <span class="d-none d-md-inline ml-2">Filtros</span>
              </button>
              <button
                @click="clearFilters"
                class="btn btn-outline-white"
                title="Limpar Filtros"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Alerta -->
      <div v-if="alertMessage" class="col-12">
        <b-alert show variant="danger">{{ alertMessage }}</b-alert>
      </div>

      <!-- Loading -->
      <div
        v-if="loading"
        class="overlay-modal d-flex align-items-center justify-content-center"
      >
        <b-spinner label="Carregando..."></b-spinner>
      </div>

      <div class="page-body">
        <div class="card bg-light-gray">
          <div class="card-body pt-1">
            <div class="table-responsive">
              <table
                role="table"
                aria-busy="false"
                aria-colcount="6"
                class="table-v3 w-100"
              >
                <thead role="rowgroup">
                  <tr role="row">
                    <th class="nowrap">NOME DO GRUPO</th>
                    <th class="nowrap">CNPJ</th>
                    <th class="nowrap">RAZÃO SOCIAL</th>
                    <th class="nowrap">QUANT. APÓLICES</th>
                    <th class="nowrap">ÚLTIMA EMISSÃO</th>
                    <th class="nowrap text-center">AÇÕES</th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                  <tr v-for="(item, idx) in items" :key="idx" role="row">
                    <td role="cell" class="font-12">{{ item.group_name }}</td>
                    <td role="cell" class="font-12">
                      {{ formatCnpj(item.cnpj) }}
                    </td>
                    <td role="cell" class="font-12">{{ item.company_name }}</td>
                    <td role="cell" class="font-12">{{ item.policies_quantity }}</td>
                    <td role="cell" class="font-12">
                      <span v-if="item.last_issue">
                        {{ formatDateLocal(item.last_issue.created_at) }}
                      </span>
                      <span v-else>----</span>
                    </td>
                    <td role="cell" class="font-12 text-center">
                      <div
                        class="d-flex align-items-center justify-content-center"
                      >
                        <button
                          class="btn btn-action"
                          @click="redirect('show-client', { economicGroupID: item.id })"
                          title="Visualizar"
                        >
                          <i class="fas fa-eye"></i>
                        </button>
                        <button
                          class="btn btn-action"
                          @click="redirect('update-client', { economicGroupID: item.id })"
                          title="Editar"
                        >
                          <i class="fas fa-pen"></i>
                        </button>
                        <button
                          class="btn btn-action"
                          @click="showModalDelete(item)"
                          title="Excluir"
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginação padrão (3 itens + setas) -->
            <nav aria-label="Paginação">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="my-table"
            @page-click="pageChanged"
          ></b-pagination>
        </nav>
          </div>
        </div>
      </div>

      <!-- Modal Excluir -->
      <b-modal
        id="show-modal-delete"
        ref="showModalDelete"
        size="md"
        class="mt-4"
        centered
        hide-footer
      >
        <template #modal-title>Excluir Grupo Econômico</template>
        <span>
          Grupo “{{ economic_group_data?.group_name }}”<br />
          CNPJ {{ economic_group_data?.cnpj | formatDocument }}
        </span>
        <div class="d-flex justify-content-end mt-3">
          <button
            class="btn btn-outline-secondary mr-2"
            @click="$bvModal.hide('show-modal-delete')"
          >
            <i class="fa fa-angle-left mr-1"></i>Voltar
          </button>
          <button class="btn btn-danger" @click="deleteEconomicGroup()">
            <i class="fas fa-times mr-1"></i>Confirmar
          </button>
        </div>
      </b-modal>

      <!-- Modal Filtros -->
      <b-modal
        id="show-modal-filter"
        ref="showModalFilter"
        size="md"
        class="mt-4"
        centered
        hide-footer
      >
        <template #modal-title>Filtrar Tomador</template>
        <div class="p-3">
          <label class="dbo-ui">Nome do Grupo</label>
          <b-form-input
            v-model="group_name"
            placeholder="Digite o nome do grupo"
          />
          <div class="d-flex justify-content-end mt-3">
            <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('show-modal-filter')">
              Cancelar
            </b-button>
            <b-button variant="primary" @click="applyFilter()">Buscar</b-button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from '@/store';
import companyService from "@/services/company";
import dateFormatter from "@/mixins/dateFormatter";
import commomsHelper from "@/mixins/commomsHelper";

export default {
  name: "list-client",
  mixins: [dateFormatter, commomsHelper],
  data: () => ({
    perPage: 10,
    currentPage: 1,
    items: [],
    totalRows: 0,
    economic_group_data: null,
    loading: false,
    group_name: "",
  }),
  created() {
    if (this.$route.query.filter) {
      let filter = { currentPage: 1, group_name: "" };
      if (this.getFiltersTableEconomicGroup && this.getFiltersTableEconomicGroup.length > 0) {
        filter = JSON.parse(this.getFiltersTableEconomicGroup.toString());
      }

      this.currentPage = filter.currentPage || 1;
      this.group_name = filter.group_name || "";
    }

    this.getEconomicGroups();
  },
  computed: {
    ...mapGetters(["getFiltersTableEconomicGroup"]),
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage) || 1;
    },
    pages() {
      const total = this.totalPages;

      if (total <= 3) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }

      if (this.currentPage === 1) {
        return [1, 2, 3];
      }

      if (this.currentPage === total) {
        return [total - 2, total - 1, total];
      }

      return [this.currentPage - 1, this.currentPage, this.currentPage + 1];
    }
  },
  methods: {
    getEconomicGroups() {
      this.loading = true;

      companyService
        .getEconomicGroups({
          group_name: this.group_name,
          page: this.currentPage,
          per_page: this.perPage,
        })
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }

          this.items = response.data.data;
          this.totalRows = response.data.total;
        })
        .catch(() => {
          this.showError("Não foi possível recuperar os grupos econômicos.");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    pageChanged(bvEvent, pageNumber) {
      this.currentPage = pageNumber;
      this.getEconomicGroups();
    },

    applyFilter() {
      this.$refs.showModalFilter.hide();
      this.currentPage = 1;

      const filter = {
        group_name: this.group_name,
        currentPage: this.currentPage,
      };

      store.commit("SET_FILTER_ECONOMIC_GROUP", JSON.stringify(filter));
      this.getEconomicGroups();
    },

    clearFilters() {
      this.group_name = "";
      this.currentPage = 1;

      const filter = {
        group_name: "",
        currentPage: 1,
      };

      store.commit("SET_FILTER_ECONOMIC_GROUP", JSON.stringify(filter));
      this.getEconomicGroups();
    },

    redirect(routeName, params = null) {
      this.$router.push({ name: routeName, params });
    },

    showModalDelete(item) {
      this.economic_group_data = item;
      this.$refs.showModalDelete.show();
    },

    deleteEconomicGroup() {
      this.loading = true;
      this.$refs.showModalDelete.hide();

      companyService
        .deleteEconomicGroup(this.economic_group_data.id)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }

          this.getEconomicGroups();
        })
        .catch(() => {
          this.showError("Não foi possível apagar o grupo econômico.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  }
};
</script>

<style scoped>
/* qualquer ajuste específico de estilo, se precisar */
</style>
